import { forkify } from '@/shared/lib/core/fork';
import handleApiError from '@/shared/api/handleApiError';

export const localStorageGet = forkify((fork, args) => {
  try {
    const [key] = args;
    const result = window.localStorage.getItem(key);
    fork.resolve(result);
  } catch (e) {
    fork.reject(e);
    handleApiError(e);
  }
});

export const localStorageSet = forkify((fork, args) => {
  try {
    const [key, value] = args;
    window.localStorage.setItem(key, value);
    fork.resolve(true);
  } catch (e) {
    fork.reject(e);
    handleApiError(e);
  }
});
